import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { getAvatarSrc, DEFAULT_AVATAR, AVATAR_NAMES } from './constants'

function FacilitatorsBox({ facilitators, teams }) {
  const { t } = useTranslation()

  const getTeamName = (teamId) => {
    if (!teamId) return null
    const team = teams.find((tm) => tm.id === teamId)
    return team?.name || null
  }

  return (
    <div className="lobby__team-slot lobby__team-slot--facilitators">
      <div className="lobby__team-slot-header">
        <div className="lobby__team-slot-title">
          <span className="lobby__team-slot-name lobby__team-slot-name--facilitators">
            {t('lobby.facilitators')}
          </span>
        </div>
        <span className="lobby__team-slot-count">{facilitators.length}</span>
      </div>
      <ul className="lobby__team-players">
        {facilitators.length === 0 ? (
          <li className="lobby__facilitators-empty">{t('lobby.no_facilitators')}</li>
        ) : (
          facilitators.map((f) => {
            const teamName = getTeamName(f.current_team_id)
            return (
              <li
                key={f.id}
                className={`lobby__team-player${
                  f.is_player ? ' lobby__team-player--facilitator-secondary' : ''
                }`}
              >
                <div className="lobby__team-player-avatar-wrapper">
                  <div className="lobby__team-player-avatar">
                    <img
                      src={getAvatarSrc(
                        f.avatar && AVATAR_NAMES.includes(f.avatar) ? f.avatar : DEFAULT_AVATAR
                      )}
                      alt=""
                      className="lobby__avatar-img"
                    />
                  </div>
                  <span
                    className="lobby__player-status-badge lobby__player-status-badge--ready"
                    style={{ backgroundColor: '#6a30c2' }}
                    aria-hidden
                  >
                    <i className="fa fa-check" />
                  </span>
                </div>
                <span className="lobby__team-player-name lobby__team-player-name--facilitator">
                  <span className="lobby__facilitator-name">{f.alias || f.email}</span>
                  {f.is_player && teamName && (
                    <span className="lobby__facilitator-team-label">
                      {t('lobby.playing_on')} {teamName}
                    </span>
                  )}
                  {!f.is_player && teamName && (
                    <span className="lobby__facilitator-team-label">({teamName})</span>
                  )}
                </span>
              </li>
            )
          })
        )}
      </ul>
    </div>
  )
}

FacilitatorsBox.propTypes = {
  facilitators: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      alias: PropTypes.string,
      email: PropTypes.string,
      avatar: PropTypes.string,
      current_team_id: PropTypes.number,
      is_player: PropTypes.bool
    })
  ),
  teams: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string
    })
  )
}

FacilitatorsBox.defaultProps = {
  facilitators: [],
  teams: []
}

export default memo(FacilitatorsBox)
